import { doc, getFirestore, onSnapshot, setDoc } from 'firebase/firestore';
import { getStorage, ref, uploadBytes } from 'firebase/storage';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { app } from '../../util/firebase';

const UpdateHospital = (props) => {
    
    const [name,setName] = useState("")
    const [adresse,setAdresse] = useState("")
    const [number,setNumber] = useState("")
    const [email,setEmail] = useState("")
    const [password,setPassword] = useState("")
    const [currentUser,setCurrentUser] = useState(null)
    const [img,setImg] = useState(null)
    const [isChecked,setIsChecked] = useState(false)

    const navigate = useNavigate()

    useEffect(()=>{
        onSnapshot(doc(getFirestore(app),"users",props.posteID),(snap)=>{
            let poste = snap.data()
            setCurrentUser(poste)
            setName(poste.userName)
            setAdresse(poste.adresse)
            setEmail(poste.email)
            setPassword(poste.password)
            setNumber(poste.phoneNumber)
            setIsChecked(true)
            
        })
    },[])
    const submit = (e)=>{
        e.preventDefault()

        let user = currentUser
        user.userName = name
        user.phoneNumber = number
        user.adresse = adresse

        if(isChecked===true){
            setDoc(doc(getFirestore(app),"users",props.posteID),user)
            .then(result=>{
                alert('Les changement sont pris en compte')
                navigate(-1)
            })
            .catch(err=>alert(err))
        }else{
            let imgUrl = user.imgSrc.substring(72,user.imgSrc.length - 10)
            imgUrl = imgUrl.replaceAll("%2F","/")
    
            let storageRef = ref(getStorage(app),imgUrl)
            uploadBytes(storageRef,img)
            .then((result)=>{
                setDoc(doc(getFirestore(app),"users",props.posteID),user)
                .then(result=>{
                    alert('Les mises a jours sont pris en compte')
                    navigate(-1)
                })
                .catch(err=>alert(err))
            })
            .catch(err=>alert(err))
        }
    }
    const archivePost=()=>{
        let user = currentUser
        user.isArchived = true
        setDoc(doc(getFirestore(app),"users",props.posteID),user)
        .then(res=> {
            alert('La poste de santé '+currentUser.userName+' a bien été archivé')
            navigate(-1)
        })
        .catch(err=>alert(err))
    }
    return (
        <div>
            <div>
                <div className='col-12 col-md-6 m-auto shadow p-3 my-3 my-md-5 '>
                    <h2 className='text-center'>Mettre a jours la poste de santé</h2>
                    <form onSubmit={e=>submit(e)}>
                        <input required className='form-control my-3' type="text" placeholder='Nom de la pharmacie' value={name} onChange={e=>setName(e.target.value)}></input>
                        <input required className='form-control my-3' type="text" placeholder='Addresse' value={adresse} onChange={e=>setAdresse(e.target.value)}></input>
                        <input required className='form-control my-3' type="number" placeholder='Numéro de téléphone' value={number} onChange={e=>setNumber(e.target.value)}></input>
                        <input disabled required className='form-control my-3' type="email" placeholder='Email' value={email} onChange={e=>setEmail(e.target.value)}></input>
                        <input disabled required className='form-control my-3' type="password" placeholder='Mot de passe' value={password} onChange={e=>setPassword(e.target.value)}></input>
                        <label className='row p-3'>
                            <div className='col-9'>
                                <input type="checkbox" checked={isChecked} onChange={e=>setIsChecked(!isChecked)}></input>
                                Garder l'image actuel
                            </div>

                            {isChecked? (<div className='col-3' style={{minHeight:'94px',backgroundImage:'url('+currentUser.imgSrc+')',backgroundSize:'cover',backgroundPosition:'center'}}></div>) :(null)}
                        </label>
                        {isChecked? (null) :(<input required className='form-control my-3' type="file" onChange={e=>setImg(e.target.files[0])}></input>)}
                        <button className='btn btn-primary col-12'>Mettre a jour ce poste de santé</button>
                        <button type='button' className='btn btn-danger col-12 my-2' onClick={archivePost}>Archiver ce poste de santé</button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default UpdateHospital;